import React, { useMemo } from 'react';
import Form from '../../../../baseComponents/gui/form/Form';
import { useTranslation } from '../../../../../translations';
import CustomModal from '../../../../baseComponents/gui/customModal/CustomModal';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import { safeHTML } from '../../../../../utils/safeHTML';
import Input from '../../../../baseComponents/gui/input/Input';
import AppLoader from '../../../../features/appLoader/AppLoader';
import { useFormErrors } from '../../../../../hooks/useFormErrors';
import { useUser } from '../../../../../redux/reducer/user';
import { getValidationTexts } from '../../../../../constants/form';
import { FOR_ID } from '../../constants/modalTypes';
import useHandleFormErrors from '../../model/hooks/useHandleFormErrors';
import useFormProps from '../../model/hooks/useFormProps';
import { useWishes } from '../../../../../redux/reducer/content';

export default function Modal({
  wishType,
  mode = 'onChange',
  title,
  badWords: _badWords,
  text,
  input,
  buttons,
  onSubmit,
}) {
  const [errors, addNewError] = useFormErrors();
  const { t } = useTranslation();
  const { defaultValue, errorNames } = useWishes();
  const { profile } = useUser();
  const badWords = useMemo(() => [...(_badWords || []), ...errorNames], []);

  const formProps = useFormProps({ wishType, input, badWords, defaultValue });
  const isPending = useHandleFormErrors({ wishType, addNewError, input, defaultValue, badWords });

  const handleSubmit = (formData) => {
    if (wishType === FOR_ID) {
      const enteredId = formData?.id;
      const myId = profile?.uid;

      if (enteredId && myId && String(enteredId) === String(myId)) {
        addNewError({ id: { message: getValidationTexts(t).IS_MY_UID } });
        return;
      }
    }

    onSubmit?.(formData);
  };

  return (
    <CustomModal animation={['fade']}>
      <div className={'wish-modal'}>
        <div className={'wish-modal__bg'} />
        <div className={'wish-modal__content'}>
          <h2 className={'wish-modal__title'}>{safeHTML(t(title))}</h2>
          <h2 className={'wish-modal__text'}>{safeHTML(t(text))}</h2>
          <div className={'wish-modal__block'}>
            <Form className={'wish-modal__form'} onSubmit={handleSubmit} errors={errors} useFormProps={{ mode }}>
              <Input {...formProps} />
              {buttons.map((props, index) => (
                <CustomButton key={index} {...props} />
              ))}
            </Form>
          </div>
        </div>
      </div>
      {isPending && <AppLoader />}
    </CustomModal>
  );
}
